import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import EntraAuthProvider from "./components/entraId/EntraAuthProvider";

ReactDOM.render(
	<EntraAuthProvider>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</EntraAuthProvider>,
	document.getElementById('root')
);
